import React from 'react'
import { motion } from 'framer-motion'

const transition = { duration: 4, yoyo: Infinity, ease: "easeInOut" }

const Arrow = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="30.113" height="30.949" viewBox="0 0 203.113 290.949" className='absolute translate-x-[-140%] rotate-[-40deg]'>
            <g>
                <motion.path 
                    initial={{ pathLength: 0 }}
                    animate={{ pathLength: 1 }}
                    transition={transition} 
                    fill={'#fff'}
                    d="M108.521,195.245c-6.358-7.961-12.945-15.809-18.158-24.592-3.126-5.535-5.972-11.224-8.666-16.978C73.982,137.406,67.383,120.3,65.971,102.2A326.918,326.918,0,0,0,116.81,65.324a94.979,94.979,0,0,0,16.809-19.278c5.1-8.792,11.223-21.166,7.844-31.4-6.687-16.8-30.842-17.2-45.141-10.891a77.909,77.909,0,0,0-36.11,35.875C50.366,59.356,50,82.217,51.025,103.8,35.423,113.816,19.4,123.89,1.763,129.869A1.95,1.95,0,0,0,0,131.488c-.084,2.556,3.218,1.24,4.664.844a139.236,139.236,0,0,0,15.066-5.692A328.346,328.346,0,0,0,51.615,110.6c2.844,24.655,13.256,47.695,24.671,69.47,7.78,13.926,18.747,25.7,30.462,36.4a185.612,185.612,0,0,0,49.847,33.3C139.166,232.975,123.6,214.214,108.521,195.245ZM65.275,85.957c.073-16.761,1.932-34.236,11.278-48.6A64.656,64.656,0,0,1,97.536,17.63a31.08,31.08,0,0,1,24.168-2.5c5.041,1.618,9.11,5.585,7.527,11.221a59.557,59.557,0,0,1-4.473,12.771C114.139,59.051,84.114,81.04,65.412,94.136,65.308,91.412,65.252,88.688,65.275,85.957Z"
                />
                <motion.path 
                    initial={{ pathLength: 0 }}
                    animate={{ pathLength: 1 }}
                    transition={transition} 
                    fill={'#fff'}
                    d="M202.86,280.177c-1.049-3.259-2.747-6.289-3.9-9.521-2.772-7.655-5.471-15.34-8.315-22.967a171.775,171.775,0,0,1-7.437-26.795c-2.262-11.393-4.9-22.864-6.54-34.392a1.46,1.46,0,0,0-.681-2.569c-3.75-.163-2.935,5.132-3.01,7.662.148,4.094.4,8.184.676,12.273.535,7.879,1.152,15.75,2.046,23.6,1.818,17.191,7.357,33.741,12.672,50.11-12.3-1.758-24.5-4.161-36.824-5.72-14.7-1.713-29.627-.705-44.336-1.3,14.537,6.186,30.24,8.644,45.344,13.031,11.968,3.363,24.15,6.456,36.594,7.293,4,.192,8.484.193,11.5-2.875A8.2,8.2,0,0,0,202.86,280.177Z"
                />
            </g>
        </svg>
    )
}

export default Arrow